import { createSelector } from 'reselect'
import entryDataSelector from './entryDataSelector'

const currencySelector = createSelector(
    entryDataSelector,
    (entryData): string => entryData.currency ?? '',
)

export default currencySelector
